import { Button } from '@bfe/moly';
import { DeviceIcon } from '@bfe/moly-icons';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';
import { trustedDeviceList } from '@/services/security';

const TrustedDevice = () => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();
  const [deviceTotal, setDeviceTotal] = useState<number>(0);
  const { userInfo } = useUserProfile();

  const devicedContext = useMemo(() => {
    return $t('NumberOfTrustedDevices').replace(
      '{{count}}',
      `<span style="font-size:14px;font-weight:600;color:var(--bds-gray-t1-title);">${deviceTotal}</span>`,
    );
  }, [$t, deviceTotal]);

  const toDevicePage = () => {
    navigate('/app/user/trusted-device');
  };

  useEffect(() => {
    if (!userInfo.id) return;
    trustedDeviceList().then((res) => {
      if (res.result) {
        const { list } = res.result;
        setDeviceTotal(list.length);
      }
    });
  }, [userInfo]);

  return (
    <AccountBasicItem
      icon="device"
      molyIcon={<DeviceIcon />}
      text={$t('TrustedDeviceMgmt')}
      subText={
        <span dangerouslySetInnerHTML={{ __html: devicedContext }}></span>
      }
      operation={
        <>
          <Button
            onClick={() => toDevicePage()}
            size="small"
            data-radius="small"
            variant="secondary"
          >
            {$t('MgmtBtnt')}
          </Button>
        </>
      }
    />
  );
};

export default TrustedDevice;
